import { ReactComponent as UserIcon } from '../icons/main_menu/users.svg';

import LiveLocationMap from './LiveLocationMap';
import UsersPage from './UsersPage';

const exports = {
    Page: UsersPage,
    // List: TripsList,
    // Edit: TripsEdit,
    Icon: UserIcon,
    LiveMap: LiveLocationMap,
};
export default exports;
